module.exports = __webpack_public_path__ + "media/beautiful-in-white.14a955d5.mp3";